import {cn} from '@sollapay/ui';
import {Skeleton, Typography} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

const GRID_COLS = 'grid-cols-[1fr_180px_120px_120px_140px_44px]';

export function TeamMemberTableSkeleton() {
  const {t} = useTranslation('team');

  const headers = [
    t('columns.member'),
    t('columns.role'),
    t('columns.status'),
    t('columns.createdAt'),
    t('columns.lastLoginAt')
  ];

  return (
    <div className="overflow-hidden rounded-xl border border-border bg-background-surface shadow-xs">
      <div
        className={cn(
          'grid h-11 items-center gap-4 border-b border-border bg-background-secondary px-6',
          GRID_COLS
        )}
      >
        {headers.map(label => (
          <Typography key={label} size="xs" weight="semibold" color="tertiary">
            {label}
          </Typography>
        ))}
        <div />
      </div>
      {Array.from({length: 6}).map((_, i) => (
        <div
          key={i}
          className={cn(
            'grid items-center gap-4 border-b border-border px-6 py-4 last:border-b-0',
            GRID_COLS
          )}
        >
          <div className="flex items-center gap-3">
            <Skeleton className="size-10 shrink-0 rounded-full" />
            <div className="flex flex-col gap-1.5">
              <Skeleton className="h-4 w-32" />
              <Skeleton className="h-3 w-40" />
            </div>
          </div>
          <Skeleton className="h-9 w-full rounded-md" />
          <Skeleton className="h-5 w-16 rounded-full" />
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-4 w-16" />
          <Skeleton className="mx-auto h-7 w-7 rounded-md" />
        </div>
      ))}
    </div>
  );
}
